import { UiStatistics } from "@app/performance/ui-statistics/UiStatistics";
import * as React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import Roles from "@app/user/roles";
import { UserContext } from "@app/user/UserContext";
import { JobStatistics } from "@app/performance/job-statistics/JobStatistics";
import { PerformanceDashboard } from "@app/performance/PerformanceDashboard";
import { NotFound } from "@app/shared/ErrorPages";

export const PerformanceRouter: React.FC<React.PropsWithChildren<RouteComponentProps>> = () => {
  const user = React.useContext(UserContext);

  if (!user || !(
    user.roles.includes(Roles.PERFORMANCE_MONITOR)
  )) {
    return <NotFound />;
  }

  return (
    <Switch>
      <Route path="/performance/dashboard" component={PerformanceDashboard} />
      <Route path="/performance/ui-statistics" component={UiStatistics} />
      <Route path="/performance/job-statistics" component={JobStatistics} />
    </Switch>
  );
}
